import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/LegalProducts.module.scss'

import { Image, Button } from 'react-bootstrap'

import CartIcon from '../icons/CartIcon'

const Icon1 = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="13.9996" height="13.9996" rx="2" fill="#1E9FF6"/>
    <path d="M7.00098 0V13.9996" stroke="white"/>
    <path d="M0.00488281 7.00391L14.0045 7.00391" stroke="white"/>
  </svg>
),
Icon2 = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="13.9996" height="13.9996" rx="2" fill="#1E9FF6"/>
  </svg>
),
Icon3 = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
    <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
  </svg>
),
Icon4 = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="12.5" fill="white"/>
    <path d="M12.75 7.5V18" stroke="#1E9FF6" strokeLinecap="round"/>
    <path d="M18 12.75L7.5 12.75" stroke="#1E9FF6" strokeLinecap="round"/>
  </svg>
)

class LegalProductsProduct extends React.Component {
  constructor(props) {
    super(props)

    var count = 0

    if(props.cart.length > 0) {
      props.cart.map( ( elm ) => {
        if( elm?.product == props.product?.id ) count+= elm?.count
      })
    }

    this.state = {
      test: 0,
      showPopup: false,
      count: count
    }

    this.popupRef = React.createRef()
    this.quantitySelectorRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    // Закрываем только если клик был вне quantitySelector и вне всплывающего окна
    if (this.state.showPopup && 
        this.quantitySelectorRef.current && 
        !this.quantitySelectorRef.current.contains(event.target) &&
        this.popupRef.current && 
        !this.popupRef.current.contains(event.target)) {
      this.setState({ showPopup: false })
    }
  }

  formatPrice(price) {
    if (!price && price !== 0) return 'Цена не указана'
    
    const numericPrice = typeof price === 'number' ? price : parseFloat(price)
    
    return numericPrice.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' ₽'
  }

  // Функция для склонения слова "штука"
  declensionShuk(count) {
    if (count % 10 === 1 && count % 100 !== 11) return 'штука'
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return 'штуки'
    return 'штук'
  }

  // Функция для склонения слова "упаковка"
  declensionUpakovka(count) {
    if (count % 10 === 1 && count % 100 !== 11) return 'упаковка'
    if ([2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100)) return 'упаковки'
    return 'упаковок'
  }

  handleQuantitySelectorClick = () => {
    this.setState(prevState => ({ showPopup: !prevState.showPopup }))
  }

  localChangeCount()
  {
    const { product, cart } = this.props
    var count = 0

    if(cart.length > 0) {
      cart.map( ( elm ) => {
        if( elm?.product == product?.id ) count+= elm?.count
      })
    }
    this.setState({
      count: count
    })
  }

  changeCountMinus = () => {
    const { count } = this.state,
    { product, addTocart } = this.props

    this.setState({ showPopup: true })

    addTocart( { product: product?.id, count: count - Number(product?.upakovka || 5) }, () => {
      this.localChangeCount()
    })
  }
  changeCountPlus = () => {
    const { count } = this.state,
    { product, addTocart } = this.props

    this.setState({ showPopup: true })

    addTocart( { product: product?.id, count: count + Number(product?.upakovka || 5) }, () => {
      this.localChangeCount()
    })
  }

  changeCountMinus2 = () => {
    const { count } = this.state,
    { product, addTocart } = this.props

    addTocart( { product: product?.id, count: count - Number(product?.upakovka * product?.ttara || 5) }, () => {
      this.localChangeCount()
    })
  }
  changeCountPlus2 = () => {
    const { count } = this.state,
    { product, addTocart } = this.props

    addTocart( { product: product?.id, count: count + Number(product?.upakovka * product?.ttara || 5) }, () => {
      this.localChangeCount()
    })
  }

  changeCount = ( value ) => {
    const { product, addTocart } = this.props

    this.setState({ showPopup: true })

    addTocart( { product: product?.id, count: Number( value ) }, () => {
      this.localChangeCount()
    })
  }

  zeroCount = () => {
    const { product, addTocart } = this.props
    addTocart( { product: product?.id, count: 0 }, () => {
      this.localChangeCount()
    })
  }

  // Функция для расчета транспортных тар
  calculateTtara = () => {
    const { count } = this.state
    const { product } = this.props
    
    if (!product?.ttara || product.ttara <= 0) return 0
    
    return Math.floor(count / product.ttara)
  }

  // Функция для расчета оставшихся упаковок
  calculateUpakovka = () => {
    const { count } = this.state
    const { product } = this.props
    
    if (!product?.ttara || product.ttara <= 0) return Math.floor(count / (product?.upakovka || 1))
    
    const remaining = count % product.ttara
    return Math.floor(remaining / (product?.upakovka || 1))
  }

  render() {
    const { product, key, authorized } = this.props
    const { showPopup, count } = this.state

    // Рассчитываем значения
    const ttaraCount = this.calculateTtara()
    const upakovkaCount = this.calculateUpakovka()

    return (
      <div key={key} className={styles.sectionGridItem}>
        <div className={styles.sectionGridItemMrow}>
          <Image className={styles.sectionGridItemImage} src={product?.image} width={50} height={52} alt={product?.pagetitle} />
          <div>
            <div className={styles.sectionGridItemPagetitle}>{product?.pagetitle}</div>
            <div className={styles.sectionGridItemLongtitle}>{product?.longtitle}</div>
          </div>
        </div>
        <div className={styles.sectionGridItemMrow}>
          {authorized &&
            <div className={styles.sectionGridItemBlock}>
              <div className={styles.sectionGridItemPrice}>
                {this.formatPrice(product?.price)}
              </div>
            </div>
          }
          {authorized &&
            <div className={styles.sectionGridItemBlock}>
              <div className={styles.sectionGridItemNds}>{product?.nds ? `C НДС` : `Без НДС`}</div>
            </div>
          }
          {authorized &&
            <div className={styles.sectionGridItemBlock}>
              <div 
                className={styles.quantitySelector}
                ref={this.quantitySelectorRef}
                onClick={this.handleQuantitySelectorClick}
              >
                <button onClick={(e) => { e.stopPropagation(); this.changeCountMinus(); }} className={styles.quantityButton}>
                  <Icon3 />
                </button>
                <input 
                  type="text" 
                  value={Math.trunc(count / product?.upakovka)}
                  className={styles.quantityInput}
                  onChange={(e) => this.changeCount(Math.trunc(e.target.value * product?.upakovka))}
                  onClick={(e) => e.stopPropagation()}
                />
                <button onClick={(e) => { e.stopPropagation(); this.changeCountPlus(); }} className={styles.quantityButton}>
                  <Icon4 />
                </button>

                {/* Всплывающее окно */}
                {showPopup && (
                  <div 
                    className={styles.popup}
                    ref={this.popupRef}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className={styles.popupContent}>
                      <div className={styles.popupContentTop}>
                        <div>{product?.pagetitle}</div>
                        <Button onClick={() => this.zeroCount()} variant='primary'>Обнулить</Button>
                      </div>
                      <div className={styles.popupContentPcount}>
                        <div>
                          Цена за упаковку<br />
                          В одной упаковке
                        </div>
                        <div>
                          {this.formatPrice(product?.price * (product?.upakovka || 1))}<br />
                          {product?.upakovka || 1} {this.declensionShuk(product?.upakovka || 1)}
                        </div>
                      </div>
                      <div className={styles.popupContentInCart}>
                        <CartIcon />
                        <div className={styles.popupContentInCartTitle}>В корзине</div>
                        <div>
                          {Math.trunc(count / product?.upakovka)} {this.declensionUpakovka(Math.trunc(count / product?.upakovka))} или {Math.trunc(count / product?.upakovka / product?.ttara)}
                        </div>
                        <Icon1 />
                      </div>
                      <div className={styles.popupContentInCline}>
                        <div>Упаковка ({product?.upakovka || 0} {this.declensionShuk(product?.upakovka || 0)})</div>
                        <Icon2 />
                      </div>
                      <div className={styles.popupContentInCline}>
                        <div>Транспортная тара ({product?.ttara || 0} {this.declensionUpakovka(product?.ttara || 0)})</div>
                        <Icon1 />
                      </div>
                      <div className={styles.quantitySelector2 + ` mt-3`}>
                        <button onClick={() => this.changeCountMinus()} className={styles.quantityButton2}>
                          <Icon3 />
                        </button>
                        <div className='d-flex align-items-center'>
                          <Icon2 />
                          <input 
                            type="text" 
                            value={Math.trunc(count / product?.upakovka)}
                            className={styles.quantityInput2}
                            onChange={(e) => this.changeCount(Math.trunc(e.target.value * product?.upakovka))}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <button onClick={() => this.changeCountPlus()} className={styles.quantityButton2}>
                          <Icon4 />
                        </button>
                      </div>
                      <div className={styles.quantitySelector2}>
                        <button onClick={() => this.changeCountMinus2()} className={styles.quantityButton2}>
                          <Icon3 />
                        </button>
                        <div className='d-flex align-items-center'>
                          <Icon1 />
                          <input 
                            type="text" 
                            value={Math.trunc(count / product?.upakovka / product?.ttara)}
                            className={styles.quantityInput2}
                            onChange={(e) => this.changeCount(Math.trunc(e.target.value * product?.upakovka * product?.ttara))}
                            onClick={(e) => e.stopPropagation()}
                          />
                        </div>
                        <button onClick={() => this.changeCountPlus2()} className={styles.quantityButton2}>
                          <Icon4 />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

LegalProductsProduct.propTypes = {
  product: PropTypes.object,
  key: PropTypes.number,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  authorized: PropTypes.bool
}

LegalProductsProduct.defaultProps = {
  product: {},
  key: 0,
  cart: [],
  authorized: false
}

export default LegalProductsProduct